// extracted by mini-css-extract-plugin
export default {"sortUpFilled":"SortingIcon-Ford_sortUpFilled__n4KXr","sortDown":"SortingIcon-Ford_sortDown__6xpQI","sortDownFilled":"SortingIcon-Ford_sortDownFilled__jbOTR"};